export default __webpack_public_path__ + "static/media/startup_banner_bg.4bca942d.png";